<div class="au-dialog-container">
	<h2 class="au-dialog-title">{{ 'edit_location' | translate }}</h2>
	<mat-icon mat-dialog-close matRipple class="close-icon">close</mat-icon>

	<form class="edit-location-form au-forms" [formGroup]="locationFormGroup">
		<div class="select-input input-with-toggle">
			<mat-form-field hideRequiredMarker class="location-building">
				<mat-label>{{ 'building' | translate }}</mat-label>
				<mat-select
					formControlName="building"
					[placeholder]="'choose_building' | translate"
					(selectionChange)="onBuildingChange($event)"
				>
					@for (building of locations; track building) {
						<mat-option [value]="building.id">
							<span>{{ building.name }}</span>
						</mat-option>
					}
				</mat-select>
				<mat-error>
					@if (buildingControl.hasError('required')) {
						<span>{{ 'required' | translate }}</span>
					}
				</mat-error>
			</mat-form-field>

			<div class="lock-toggle" (click)="toggleBuildingControl()">
				<mat-icon [svgIcon]="buildingControl.disabled ? 'lock' : 'unloc'"></mat-icon>
				<div class="lock-info">
					<p>{{ 'change_building_location_warning' | translate }}</p>
				</div>
			</div>
		</div>

		<div class="select-input">
			<mat-form-field hideRequiredMarker class="location-room">
				<mat-label>{{ 'room' | translate }}</mat-label>
				<mat-select formControlName="room" [placeholder]="'choose_room' | translate">
					@for (floor of getBuildingFloors(); track floor) {
						<mat-optgroup [label]="floor.name">
							@for (room of floor.room; track room) {
								<mat-option [value]="room.id">
									{{ room.name }}
								</mat-option>
							}
						</mat-optgroup>
					}
				</mat-select>
				<mat-error>
					@if (roomControl.hasError('required')) {
						<span>{{ 'required' | translate }}</span>
					}
				</mat-error>
			</mat-form-field>
		</div>
	</form>
</div>
<mat-dialog-actions>
	<au-techno-btn mat-dialog-close>{{ 'cancel' | translate }}</au-techno-btn>
	<button
		matRipple
		[disabled]="!locationFormGroup.valid"
		class="au-btn m-l-sm uppercase save-button"
		(click)="save()"
	>
		{{ 'save' | translate }}
	</button>
</mat-dialog-actions>
